module.exports = {
	"no": {
		"conversation": {
			"widget": {
				"title": "Chat med oss"
			}
		}
	}
};